 
<div class="row" *ngIf="listsLoaded==false">

    <div class="col-sm-12">
      One moment please...
    </div>
  
  </div>
  
  <div class="row " *ngIf="listsLoaded==true">
  
    <div class="col-sm-12 searchControls">
      
      <div class='gridCell'> 
        <div> 
            <label for="">Season</label> 
            <select [(ngModel)]="model.seasonId"> 
              <option value="0">All Seasons</option>
              <option value="-1">No Seasons</option> 
              <option *ngFor="let section of seasons" [ngValue]="section.Id">
                {{section.Localized[0].Name}}
              </option>
            </select> 
        </div>
      </div>
      
      <div class='gridCell'> 
        <div> 
            <label for="">Feast Type</label> 
            <select [(ngModel)]="model.feastTypeId"> 
              <option value="0">All</option> 
              <option *ngFor="let section of feastTypes" [ngValue]="section.Id">
                {{section.Localized[0].Name}}
              </option>
            </select> 
        </div>
      </div>

      <div class='gridCell'> 
        <div> 
            <label for="">Lectionary Source</label> 
            <select [(ngModel)]="model.lectionarySourceId">             
              <option></option>
              <option *ngFor="let section of lectionarySources" [ngValue]="section.Id">
                {{section.Name}} ({{section.NameAbbreviated}})
              </option>
            </select> 
        </div>
      </div>
   
      <div class='gridCell' style="align-self:end">
          <button (click)="search()">Search</button>
      </div> 

    </div>
   
  
  </div>
  